/**
 * Published Language Contract - GTD Domain → Downstream Contexts
 * 
 * Defines the query criteria interface that GTD Domain exposes
 * for inbox item queries. This is part of the Published Language
 * following Eric Evans Strategic DDD patterns.
 */

export interface InboxQueryCriteria {
  /**
   * Filter by processing status
   */
  status?: 'unprocessed' | 'processed' | 'all';
  
  /**
   * Maximum number of items to return
   */
  limit?: number;
  
  /**
   * Starting offset for pagination
   */
  offset?: number;
  
  /**
   * Filter by priority level
   */
  priority?: 'low' | 'medium' | 'high' | 'urgent';
  
  /**
   * Search term to filter content
   */
  searchTerm?: string;
  
  /**
   * Filter by who captured the item
   */
  capturedByPersonId?: string;
  
  /**
   * Filter by capture date range
   */
  capturedAfter?: string; // ISO date string
  capturedBefore?: string; // ISO date string
}

/**
 * Result metadata for paginated queries
 */
export interface InboxQueryResult<T> {
  items: T[];
  totalCount: number;
  hasMoreResults: boolean;
  offset: number;
  limit: number;
}